<span
  class="cads-processing-spinner"
  [class.cads-processing-spinner--compact]="_isCompact()"
  [attr.role]="_accessibleLabel() ? 'status' : null"
  [attr.aria-label]="_accessibleLabel()"
  [attr.aria-hidden]="_accessibleLabel() ? null : true"
  [style.--cads-processing-spinner-color]="_color()"
>
  @for (arm of _arms; track arm) {
    <span class="cads-processing-spinner__arm" [style.--cads-processing-spinner-arm-index]="arm">
      <span class="cads-processing-spinner__dot"></span>
    </span>
  }
</span>
